/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React, { Component} from 'react';
import Select from 'react-select';
import PropTypes from "prop-types";
import {SEARCH_OPTIONS} from '../../../constants/APP_CONSTANTS';


export class Search extends Component {
    static get propTypes () {
        return {
            updateSearchParams: PropTypes.func.isRequired
        };
    }

    constructor(props){
        super();
        this.onChange = this.onChange.bind(this);
        this.generatePlaceholderTextAndUpdateProps = this.generatePlaceholderTextAndUpdateProps.bind(this);
        this.state = {
            selectedValue : {
                value: '0',
                label: 'Filter Options'
            },
            placeholder: SEARCH_OPTIONS.FILTER,
            datepicker: false,
            searchDisabled: true,
            dropDownOptions : [{
                value: '0',
                label: 'Filter Options'
            },{
                value: '1',
                label: 'Resource Id'
            },{
                value: '2',
                label: 'List of Resource Id'
            },{
                value: '3',
                label: 'Filename'
            },{
                value: '4',
                label: 'Resource Date'
            },{
                value: '5',
                label: 'ISBN'
            },{
                value: '6',
                label: 'List of File names'
            },{
                value: '7',
                label: 'Eps ID'
            },{
                value: '8',
                label: 'Asset Title'
            }]
        };
    }

    onChange(e){
        this.setState({selectedValue: {value: e.value, label: e.label}});
        this.generatePlaceholderTextAndUpdateProps(e.value);
    }

    generatePlaceholderTextAndUpdateProps(value){
        let params = '';
        switch(value) {
            case '0':
                params = {
                    placeholder: SEARCH_OPTIONS.FILTER,
                    datepicker: false,
                    searchDisabled: true
                };
                break;
            case '1':
                params = {
                    searchParam: 'metadatabyId',
                    placeholder: SEARCH_OPTIONS.RESOURCEID,
                    datepicker: false,
                    searchDisabled: false
                };
                break;
            case '2':
                params ={
                    searchParam: 'metadataByIds',
                    placeholder: SEARCH_OPTIONS.RESOURCEIDLIST,
                    datepicker: false,
                    searchDisabled: false
                };
                break;
            case '3':
                params = {
                    searchParam: 'metadatabyname',
                    placeholder: SEARCH_OPTIONS.FILENAME,
                    datepicker: false,
                    searchDisabled: false
                };
                break;
            case '4':
                params ={
                    searchParam: 'metadatabydate',
                    datepicker: true,
                    searchDisabled: false
                };
                break;
            case '5':
                params = {
                    searchParam: 'metadataByISBN',
                    placeholder: SEARCH_OPTIONS.ISBN,
                    datepicker: false,
                    searchDisabled: false
                };
                break;
            case '6':
                params = {
                    searchParam: 'metadataByFileNames',
                    placeholder: SEARCH_OPTIONS.FILENAMELIST,
                    datepicker: false,
                    searchDisabled: false
                };
                break;
            case '7':
                params = {
                    searchParam: 'metadataByEpsId',
                    placeholder: SEARCH_OPTIONS.EPSID,
                    datepicker: false,
                    searchDisabled: false
                };
                break;
            case '8':
                params = {
                    searchParam: 'metadataByAssetTitle',
                    placeholder: SEARCH_OPTIONS.ASSETTITLE,
                    datepicker: false,
                    searchDisabled: false
                };
                break;
            default:
        }
        this.props.updateSearchParams(params);
    }

    render() {

        return(
            <div >
                <div className="pe-row ">
                    <div className='pe-col-12 search-type'>
                        <label className="pe-page-title--secondary search-title"> Search </label>
                    </div>
                </div>
                <div className='dropdown'>
                    <Select arrowRenderer={this.props.arrowRenderer || this.arrowDown}
                        backspaceRemoves={false}
                        clearable={false}
                        name={this.state.selectedValue.label}
                        onChange={(e)=> this.onChange(e)}
                        options={this.state.dropDownOptions}
                        searchable={false}
                        value={this.state.selectedValue.value}
                    />
                </div>

            </div>);
    }
}


// WEBPACK FOOTER //
// ./src/components/pages/ContentManagement/SearchComponent.js